import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { AuthProvider, useAuth } from './context/AuthContext';
// Importaciones de componentes
//Login
import LoginPage from './pages/LoginPage';
//layouts
import MainLayout from './layouts/MainLayout';
//Dashboard
import DashboardPage from './pages/Dashboard/DashboardPage';
//Users
import UsersPage from './pages/Clients/UsersPage';
import AddCliente from './pages/Clients/AddCliente/AddCliente';
//Proyects
import Proyects from './pages/Proyects/Proyects';
import AddProyect from './pages/Proyects/AddProyect/AddProyect';
//ProyectManager
import ProyectManager from './pages/ProyectManager/ProyectManager';
import AddProyectManager from './pages/ProyectManager/AddProyectManager/AddProyectManager';
//Support
import Support from './pages/Support/Support';
import Ticket from './pages/Support/Ticket/Ticket';
//AdminUsuarios
import AdminUsuariosPage from './pages/AdminUsuarios/AdminUsuariosPage';
//AdminPlanes
import AdminPlanesPage from './pages/AdminPlanes/AdminPlanesPage';
//Profile
import ProfilePage from './pages/Profile/ProfilePage';
//AdminCuentas
import AdminCuentasPage from './pages/AdminCuentas/AdminCuentasPage';
//AdminPrecios / AdminCostos
import AdminPreciosPage from './pages/AdminPrecios/AdminPreciosPage';
import AgentTypesPage from './pages/AgentTypes/AgentTypesPage';
import AdminCostosPage from './pages/AdminCostos/AdminCostosPage';
// Importaciones de React Toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Importaciones de SweetAlert2
import 'sweetalert2/dist/sweetalert2.min.css';
// Estilos personalizados para SweetAlert2
import './styles/sweetalert2-custom.css';
// Estilos personalizados para Toastify
import './styles/toastify-custom.css';

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </AuthProvider>
    </MotionConfig>
  );
}

// Separate component to use the auth hook inside the AuthProvider
const AppContent = () => {
  const { isAuthenticated, role } = useAuth();

  // Componente para proteger rutas que requieren autenticación y rol admin
  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    if (role !== 'admin') return <Navigate to="/login" replace />;
    return children;
  };
  
  return (
    <Routes>
      <Route path="/login" element={(isAuthenticated && role === 'admin') ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/" element={
        <ProtectedRoute>
          <MainLayout/>
        </ProtectedRoute>
      }>
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardPage/>
          </ProtectedRoute>
        } />
        <Route path="/clients" element={
          <ProtectedRoute>
            <UsersPage/>
          </ProtectedRoute>
        } />
        <Route path="/clients/add" element={
          <ProtectedRoute>
            <AddCliente/>
          </ProtectedRoute>
        } />
        <Route path="/clients/edit" element={
          <ProtectedRoute>
            <AddCliente/>
          </ProtectedRoute>
        } />
        <Route path="/proyects" element={
          <ProtectedRoute>
            <Proyects/>
          </ProtectedRoute>
        } />
        <Route path="/proyects/add" element={
          <ProtectedRoute>
            <AddProyect/>
          </ProtectedRoute>
        } />
        <Route path="/proyects/edit" element={
          <ProtectedRoute>
            <AddProyect/>
          </ProtectedRoute>
        } />
        <Route path="/proyect_manager" element={
          <ProtectedRoute>
            <ProyectManager/>
          </ProtectedRoute>
        } />
        <Route path="/proyect_manager/add" element={
          <ProtectedRoute>
            <AddProyectManager/>
          </ProtectedRoute>
        } />
        <Route path="/support" element={
          <ProtectedRoute>
            <Support/>
          </ProtectedRoute>
        } />
        <Route path="/support/ticket" element={
          <ProtectedRoute>
            <Ticket/>
          </ProtectedRoute>
        } />
        <Route path="/admin-usuarios" element={
          <ProtectedRoute>
            <AdminUsuariosPage/>
          </ProtectedRoute>
        } />
        <Route path="/admin-planes" element={
          <ProtectedRoute>
            <AdminPlanesPage/>
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <ProfilePage/>
          </ProtectedRoute>
        } />
        <Route path="/admin-cuentas" element={
          <ProtectedRoute>
            <AdminCuentasPage/>
          </ProtectedRoute>
        } />
        <Route path="/agent-types" element={
          <ProtectedRoute>
            <AgentTypesPage/>
          </ProtectedRoute>
        } />
        <Route path="/admin-precios" element={
          <ProtectedRoute>
            <AdminPreciosPage/>
          </ProtectedRoute>
        } />
        <Route path="/admin-costos" element={
          <ProtectedRoute>
            <AdminCostosPage/>
          </ProtectedRoute>
        } />
      </Route>
    </Routes>
  );
};

export default App;
